<template lang="html">
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Avaliação</span>
        <h3 class="page-title">Questões</h3>
      </d-col>
    </d-row>
    <d-row class="mb-2">
      <d-col cols="12" v-if="!editTitle">
        <h2 class="page-title" @click="changeTitle">{{ rating.name }}</h2>
      </d-col>
      <d-col cols="12" class="page-title px-3" v-else>
        <d-input v-model="name" @blur.native="saveName"></d-input>
      </d-col>
    </d-row>


    <!-- Content -->
    <questions ref="questionsForm" :rating="rating" />
  </d-container>
</template>


<script>
import { mapActions } from 'vuex';
import { cloneDeep, stringfy } from '_utils';
import Events from '_utils/events';
import Questions from '_modules/rating/components/Questions.vue';
import { _LOAD_MODEL_, MODEL_RATING } from '../components/RatingModel';

export default {
  name: 'rating-questions',
  components: {
    Questions,
  },
  computed: {
    rating() {
      const { rating } = this.$store.state.rating;
      if (rating) {
        Events.$emit(_LOAD_MODEL_, rating);
        return rating;
      }
      return cloneDeep(MODEL_RATING);
    },
  },
  data() {
    return {
      editTitle: false,
      name: null,
    };
  },
  methods: {
    ...mapActions([
      'getRating',
      'activeAlert',
      'updateRating',
    ]),
    changeTitle() {
      this.editTitle = !this.editTitle;
      this.name = this.rating.name;
    },
    getRatingModel() {
      this.getRating(parseInt(this.$route.params.ratingId, Number));
    },
    saveName() {
      const rating = {
        id: this.rating.id,
        name: this.name,
        slug: stringfy(this.name),
      };
      this.updateRating(rating)
        .then(() => {
          this.activeAlert({ message: 'Nome alterado com sucesso', theme: 'success' });
          this.editTitle = false;
        });
    },
  },
  mounted() {
    if (this.$route.params.ratingId) {
      this.getRatingModel();
    }
  },
};
</script>

